import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = {
  loading: false,
  fetchedVehicle: false,
  pagination: {},
  vehicles: [],
  vehicle: {},
  brokers: [],
  assetClasses: [],
  vehiclesTypes: [],
  vehiclesTypeCategories: [],
  availablesBrokers: [],
  loadingVehicleType: false,
  loadingDeleteVehicle: false,
  loadingAssetClasses: false,
  fetchUpdateVehicleGroup: FETCH_STATE.UNSENT,
  loadingVehiclesTypes: false,
  conflictingVehicles: [],
  loadingVehiclesTypeCategories: false,
  fetchingAvailablesBrokers: false,
  errors: {},
  onboarding: {
    exitOnboarding: false,
    currentGroup: '',
    exitStep: false,
    lastStep: false,
    position: 0,
    errors: {},
    steps: {},
  },
  fetchingVehicles: FETCH_STATE.UNSENT,
  fetchingImageAction: false,
  fetchingChangeStatus: false,
  fetchingBulkUnshareServices: false,
  fetchedBulkUnshareServices: false,
  fetchedDeleteVehicleSuccess: false,
  fetchedChangeStatusSuccess: false,
  fetchedChangeServicesSuccess: false,
  fetchedChangeBrokersSuccess: false,
  fetchedVehicleTypeSuccess: false,
  fetchedVehiclesTypeCategoriesSuccess: false,
  orgs: [],
  fetchingOrgs: FETCH_STATE.UNSENT,
  brokerSettings: {},
  fetchedBrokerSettingsSuccess: FETCH_STATE.UNSENT,
  updatedBrokerSettingsSucces: FETCH_STATE.UNSENT,
  loadingVehicleStatuses: FETCH_STATE.UNSENT,
  vehicleStatuses: [],
  vehicleStatusesPagination: {},
};

const vehicleReducer = createReducer(initialState)({
  // GET VEHICLES
  [types.FETCH_VEHICLES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingVehicles: FETCH_STATE.LOADING,
    };
  },
  [types.RESET_VEHICLES_SUCCESS]: (state) => {
    return {
      ...state,
      vehicles: initialState.vehicles,
      pagination: initialState.pagination,
    };
  },
  [types.FETCH_VEHICLES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingVehicles: FETCH_STATE.DONE,
      vehicles: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_VEHICLES_FAILED]: (state, { error }) => {
    return {
      ...state,
      fetchingVehicles: FETCH_STATE.ERROR,
      errors: {
        vehicles: error,
      },
    };
  },
  // GET VEHICLES BY ID
  [types.FETCH_VEHICLE_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_VEHICLE_BY_ID_SUCCESS]: (state, { payload, page }) => {
    const data =
      page === 'details'
        ? { vehicle: payload }
        : {
            onboarding: {
              ...state.onboarding,
              steps: {
                ...state.onboarding.steps,
                details: payload,
              },
              errors: {},
            },
          };
    return {
      ...state,
      loading: false,
      ...{ ...data },
    };
  },
  [types.FETCH_VEHICLE_BY_ID_FAILED]: (state, { error }) => {
    return {
      ...state,
      loading: false,
      vehicle: {},
      errors: {
        vehicles: error,
      },
    };
  },
  // GET VEHICLES ORGS BY ID
  [types.FETCH_VEHICLE_ORGS_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      orgs: [],
      fetchingOrgs: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_VEHICLE_ORGS_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingOrgs: FETCH_STATE.ERROR,
      orgs: payload,
    };
  },
  [types.FETCH_VEHICLE_ORGS_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      fetchingOrgs: FETCH_STATE.FAILED,
    };
  },
  //DELETE VEHICLE
  [types.FETCH_DELETE_VEHICLE_REQUEST]: (state) => {
    return {
      ...state,
      loadingDeleteVehicle: true,
    };
  },
  [types.FETCH_DELETE_VEHICLE_SUCCESS]: (state) => {
    return {
      ...state,
      loadingDeleteVehicle: false,
      fetchedDeleteVehicleSuccess: true,
    };
  },
  [types.FETCH_DELETE_VEHICLE_FAILED]: (state, { error }) => {
    return {
      ...state,
      loadingDeleteVehicle: false,
      errors: error,
    };
  },
  // GET VEHICLES BY ID
  [types.FETCH_VEHICLE_BROKERS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_VEHICLE_BROKERS_SUCCESS]: (state, { payload }) => {
    const data = !payload.step
      ? { brokers: payload }
      : {
          onboarding: {
            ...state.onboarding,
            steps: {
              ...state.onboarding.steps,
              [payload.step]: {
                ...state.onboarding.steps[payload.step],
                activeBrokers: payload.data,
              },
            },
            errors: {},
          },
        };
    return {
      ...state,
      loading: false,
      ...{ ...data },
    };
  },
  [types.FETCH_VEHICLE_BROKERS_FAILED]: (state, { error }) => {
    return {
      ...state,
      loading: false,
      errors: {
        brokers: error,
      },
    };
  },
  // GET VEHICLES ASSET CLASSES
  [types.FETCH_VEHICLES_ASSET_CLASSES_REQUEST]: (state) => {
    return {
      ...state,
      loadingAssetClasses: true,
    };
  },
  [types.FETCH_VEHICLES_ASSET_CLASSES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loadingAssetClasses: false,
      assetClasses: payload,
    };
  },
  [types.FETCH_VEHICLES_ASSET_CLASSES_FAILED]: (state, { error }) => {
    return {
      ...state,
      loadingAssetClasses: false,
      errors: {
        assetClasses: error,
      },
    };
  },
  // CREATE VEHICLE
  [types.FETCH_CREATE_VEHICLE_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      onboarding: {
        ...state.onboarding,
        errors: {},
      },
    };
  },
  [types.FETCH_CREATE_VEHICLE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        steps: {
          ...state.onboarding.steps,
          [payload.step]: payload.data,
        },
      },
    };
  },
  [types.FETCH_CREATE_VEHICLE_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        errors: payload?.errors || {},
      },
    };
  },
  [types.UPDATE_VEHICLE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      vehicle: payload.data,
    };
  },
  // GET VEHICLES TYPES
  [types.FETCH_VEHICLES_TYPES_REQUEST]: (state) => {
    return {
      ...state,
      loadingVehiclesTypes: true,
    };
  },
  [types.FETCH_VEHICLES_TYPES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loadingVehiclesTypes: false,
      vehiclesTypes: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_VEHICLES_TYPES_FAILED]: (state, { error }) => {
    return {
      ...state,
      loadingVehiclesTypes: false,
      errors: {
        assetClasses: error,
      },
    };
  },

  // GET VEHICLE TYPE BY ID
  [types.FETCH_VEHICLE_TYPE_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loadingVehicleType: true,
    };
  },
  [types.FETCH_VEHICLE_TYPE_BY_ID_SUCCESS]: (state, { payload }) => {
    const data = {};
    if (payload?.type) {
      data.vehiclesTypes = [payload.data];
    }
    return {
      ...state,
      loadingVehicleType: false,
      vehicleType: payload?.data || payload,
      ...data,
    };
  },
  [types.FETCH_VEHICLE_TYPE_BY_ID_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loadingVehicleType: false,
      vehicleType: {},
      errors: payload?.errors || {},
    };
  },
  // GET VEHICLE TYPE CATEGORIES
  [types.FETCH_VEHICLE_TYPE_CATEGORIES_REQUEST]: (state) => {
    return {
      ...state,
      loadingVehiclesTypeCategories: true,
    };
  },
  [types.FETCH_VEHICLE_TYPE_CATEGORIES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loadingVehiclesTypeCategories: false,
      vehiclesTypeCategories: payload?.data,
    };
  },
  [types.FETCH_VEHICLE_TYPE_CATEGORIES_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loadingVehicleTypeCategories: false,
      vehicleTypeCategories: [],
      errors: payload?.errors || {},
    };
  },
  [types.RESET_VEHICLES_TYPE_CATEGORIES_SUCCESS]: (state) => {
    return {
      ...state,
      loadingVehiclesTypeCategories: false,
      vehiclesTypeCategories: [],
      errors: {},
    };
  },
  // CREATE VEHICLE TYPE
  [types.CREATE_VEHICLE_TYPE_REQUEST]: (state) => {
    return {
      ...state,
      loadingVehicleType: true,
    };
  },
  [types.CREATE_VEHICLE_TYPE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loadingVehicleType: false,
      fetchedVehicleTypeSuccess: true,
      vehicleType: payload,
    };
  },
  [types.CREATE_VEHICLE_TYPE_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loadingVehicleType: false,
      errors: payload?.errors || {},
    };
  },
  // UPDATE VEHICLE TYPE
  [types.UPDATE_VEHICLE_TYPE_REQUEST]: (state) => {
    return {
      ...state,
      loadingVehicleType: true,
    };
  },
  [types.UPDATE_VEHICLE_TYPE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loadingVehicleType: false,
      fetchedVehicleTypeSuccess: true,
      vehicleType: payload,
    };
  },
  [types.UPDATE_VEHICLE_TYPE_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loadingVehicleType: false,
      errors: payload?.errors || {},
    };
  },
  // UPDATE VEHICLE GROUP
  [types.UPDATE_VEHICLE_GROUP_REQUEST]: (state) => {
    return {
      ...state,
      fetchUpdateVehicleGroup: FETCH_STATE.LOADING,
    };
  },
  [types.UPDATE_VEHICLE_GROUP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      vehicle: payload.data,
      fetchUpdateVehicleGroup: FETCH_STATE.DONE,
    };
  },
  [types.UPDATE_VEHICLE_GROUP_FAILED]: (state) => {
    return {
      ...state,
      fetchUpdateVehicleGroup: FETCH_STATE.ERROR,
    };
  },
  // RESET VEHICLE TYPE ONBOARDING
  [types.RESET_VEHICLE_TYPE_ONBOARDING]: (state) => {
    return {
      ...state,
      loadingVehicleType: false,
      fetchedVehicleTypeSuccess: false,
      vehicleType: {},
      errors: {},
    };
  },
  // ADD SERVICE TO VEHICLES
  [types.FETCH_ADD_SERVICES_TO_VEHICLES_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedChangeServicesSuccess: false,
    };
  },
  [types.FETCH_ADD_SERVICES_TO_VEHICLES_SUCCESS]: (state, { payload }) => {
    const { step, data } = payload;
    const { onboarding } = state;
    return {
      ...state,
      loading: false,
      fetchedChangeServicesSuccess: true,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            to_orgs: [...(onboarding?.steps[step]?.to_orgs || []), data],
          },
        },
      },
    };
  },
  [types.FETCH_ADD_SERVICES_TO_VEHICLES_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedChangeServicesSuccess: false,
    };
  },
  // REMOVE SERVICE TO VEHICLES
  [types.FETCH_REMOVE_SERVICES_TO_VEHICLES_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedChangeServicesSuccess: false,
    };
  },
  [types.FETCH_REMOVE_SERVICES_TO_VEHICLES_SUCCESS]: (state, { payload }) => {
    const { step, data } = payload;
    const { onboarding } = state;

    let to_orgs = [];
    (onboarding?.steps[step]?.to_orgs || []).forEach((val) => {
      if (val.organization.id !== data) {
        to_orgs.push(val);
      }
    });

    return {
      ...state,
      loading: false,
      fetchedChangeServicesSuccess: true,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            to_orgs: to_orgs,
          },
        },
      },
    };
  },
  [types.FETCH_REMOVE_SERVICES_TO_VEHICLES_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedChangeServicesSuccess: false,
    };
  },
  // ADD BROKER
  [types.FETCH_ADD_BROKER_REQUEST]: (state) => {
    return {
      ...state,
      fetchedChangeBrokersSuccess: false,
      loading: true,
    };
  },
  [types.FETCH_ADD_BROKER_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedChangeBrokersSuccess: true,
      loading: false,
    };
  },
  [types.FETCH_ADD_BROKER_FAILED]: (state, { payload }) => {
    return {
      ...state,
      fetchedChangeBrokersSuccess: false,
      errors: payload.errors,
      loading: false,
    };
  },
  // REMOVE BROKER
  [types.FETCH_REMOVE_BROKER_REQUEST]: (state) => {
    return {
      ...state,
      fetchedChangeBrokersSuccess: false,
      loading: true,
    };
  },
  [types.FETCH_REMOVE_BROKER_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedChangeBrokersSuccess: true,
      loading: false,
    };
  },
  [types.FETCH_REMOVE_BROKER_FAILED]: (state) => {
    return {
      ...state,
      fetchedChangeBrokersSuccess: false,
      loading: false,
    };
  },
  // UPDATE STEPS LIST
  [types.UPDATE_STEPS_LISTS_REQUEST]: (state, { payload }) => {
    const { onboarding } = state;
    const { step, listName } = payload;

    return {
      ...state,
      loading: true,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            [listName]: {
              ...onboarding?.steps?.[step]?.[listName],
              list: [],
              loading: true,
            },
          },
        },
        errors: {},
      },
    };
  },
  [types.UPDATE_STEPS_LISTS_SUCCESS]: (state, { payload }) => {
    const { onboarding } = state;
    const { step, listName } = payload;

    return {
      ...state,
      loading: false,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            [listName]: {
              loading: false,
              ...payload.data,
            },
          },
        },
      },
    };
  },
  [types.UPDATE_STEPS_LISTS_FAILED]: (state, { payload }) => {
    const { onboarding } = state;
    const { step, listName, errors } = payload;
    return {
      ...state,
      loading: false,
      onboarding: {
        ...onboarding,
        steps: {
          ...onboarding.steps,
          [step]: {
            ...onboarding.steps[step],
            [listName]: {
              ...state?.onboarding?.steps?.[step]?.[listName],
              loading: false,
            },
          },
        },
        errors: errors,
      },
    };
  },
  // RESET VEHICLES TYPES
  [types.RESET_VEHICLES_TYPES_SUCCESS]: (state) => {
    return {
      ...state,
      vehiclesTypes: [],
    };
  },
  // ONBOARDING CHANGE POSITION
  [types.CHANGE_POSITION]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        position: payload.position,
      },
    };
  },
  // RESET ONBOARDING
  [types.RESET_ONBOARDING]: (state) => {
    return {
      ...state,
      onboarding: {
        exitOnboarding: false,
        currentGroup: '',
        exitStep: false,
        lastStep: false,
        position: 0,
        errors: {},
        steps: {},
      },
    };
  },

  [types.SET_EXIT]: (state, { payload }) => {
    return {
      ...state,
      onboarding: {
        ...state.onboarding,
        [payload.type]: payload.exit,
      },
    };
  },
  // CHANGE VEHICLE GROUP
  [types.CHANGE_VEHICLE_GROUP_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.CHANGE_VEHICLE_GROUP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      onboarding: {
        ...state.onboarding,
        steps: {
          ...state.onboarding.steps,
          details: payload.data,
        },
        errors: {},
      },
    };
  },
  [types.CHANGE_VEHICLE_GROUP_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // CHANGE VEHICLE STATUS
  [types.CHANGE_VEHICLE_STATUS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingChangeStatus: true,
      errors: {},
      fetchedChangeStatusSuccess: false,
    };
  },
  [types.CHANGE_VEHICLE_STATUS_SUCCESS]: (state, { payload, page }) => {
    const data = page
      ? { vehicle: payload }
      : {
          onboarding: {
            ...state.onboarding,
            steps: {
              ...state.onboarding.steps,
              details: payload,
            },
            lastStep: true,
          },
        };
    return {
      ...state,
      ...{ ...data },
      errors: {},
      fetchingChangeStatus: false,
      fetchedChangeStatusSuccess: true,
    };
  },
  [types.CHANGE_VEHICLE_STATUS_FAILED]: (state, { payload, page }) => {
    const data = page
      ? { errors: payload?.errors }
      : {
          onboarding: {
            ...state.onboarding,
            lastStep: true,
            errors: payload?.errors,
          },
        };
    return {
      ...state,
      ...{ ...data },
      fetchingChangeStatus: false,
      fetchedChangeStatusSuccess: false,
    };
  },
  [types.CHANGE_VEHICLE_STATUS_CONFLICT]: (state, { payload }) => {
    const data = { conflictingVehicles: payload?.conflictingVehicles };
    return {
      ...state,
      ...{ ...data },
      fetchingChangeStatus: false,
      fetchedChangeStatusSuccess: false,
    };
  },
  // SET VEHICLE ACTION
  [types.SET_VEHICLE_ACTION_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.SET_VEHICLE_ACTION_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.SET_VEHICLE_ACTION_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // RESET CHANGE STATUS
  [types.RESET_CHANGE_STATUS_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      errors: {},
      conflictingVehicles: null,
      fetchingChangeStatus: false,
      fetchedChangeStatusSuccess: false,
    };
  },
  // RESET DELETE VEHICLE
  [types.RESET_DELETE_VEHICLE_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      errors: {},
      loadingDeleteVehicle: false,
      fetchedDeleteVehicleSuccess: false,
    };
  },
  // SET VEHICLE PROFILE IMAGE
  [types.SET_VEHICLE_PROFILE_IMAGE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingImageAction: true,
    };
  },
  [types.SET_VEHICLE_PROFILE_IMAGE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingImageAction: false,
      vehicle: payload,
    };
  },
  [types.SET_VEHICLE_PROFILE_IMAGE_FAILED]: (state) => {
    return {
      ...state,
      fetchingImageAction: false,
    };
  },
  // DELETE VEHICLE IMAGE
  [types.DELETE_VEHICLE_IMAGES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingImageAction: true,
    };
  },
  [types.DELETE_VEHICLE_IMAGES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingImageAction: false,
      vehicle: payload || state.vehicle,
    };
  },
  [types.DELETE_VEHICLE_IMAGES_FAILED]: (state) => {
    return {
      ...state,
      fetchingImageAction: false,
    };
  },
  // SET VEHICLE TYPE PROFILE IMAGE
  [types.SET_VEHICLE_TYPE_PROFILE_IMAGE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingImageAction: true,
    };
  },
  [types.SET_VEHICLE_TYPE_PROFILE_IMAGE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingImageAction: false,
      vehicleType: payload,
    };
  },
  [types.SET_VEHICLE_TYPE_PROFILE_IMAGE_FAILED]: (state) => {
    return {
      ...state,
      fetchingImageAction: false,
    };
  },
  // DELETE VEHICLE TYPE IMAGE
  [types.DELETE_VEHICLE_TYPE_IMAGES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingImageAction: true,
    };
  },
  [types.DELETE_VEHICLE_TYPE_IMAGES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingImageAction: false,
      vehicleType: payload || state.vehicleType,
    };
  },
  [types.DELETE_VEHICLE_TYPE_IMAGES_FAILED]: (state) => {
    return {
      ...state,
      fetchingImageAction: false,
    };
  },
  // UPLOAD VEHICLE TYPE IMAGE
  [types.UPLOAD_VEHICLE_TYPE_IMAGE_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchingUploadVehicleTypeImage: true,
    };
  },
  [types.UPLOAD_VEHICLE_TYPE_IMAGE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      vehicleType: payload,
      fetchingUploadVehicleTypeImage: false,
      fetchedUploadVehicleTypeImageSuccess: true,
    };
  },
  [types.UPLOAD_VEHICLE_TYPE_IMAGE_FAILED]: (state) => {
    return {
      ...state,
      fetchingUploadVehicleTypeImage: false,
    };
  },
  // GET AVAILABLES BROKERS
  [types.FETCH_AVAILABLES_BROKERS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAvailablesBrokers: true,
    };
  },
  [types.FETCH_AVAILABLES_BROKERS_SUCCESS]: (state, { payload }) => {
    const data = !payload.step
      ? { availablesBrokers: payload?.data }
      : {
          onboarding: {
            ...state.onboarding,
            steps: {
              ...state.onboarding.steps,
              [payload.step]: {
                ...state.onboarding.steps[payload.step],
                availablesBrokers: payload?.data,
              },
            },
            errors: {},
          },
        };
    return {
      ...state,
      fetchingAvailablesBrokers: false,
      ...{ ...data },
    };
  },
  [types.FETCH_AVAILABLES_BROKERS_FAILED]: (state) => {
    return {
      ...state,
      fetchingAvailablesBrokers: false,
    };
  },
  // UPLOAD VEHICLE IMAGE
  [types.UPLOAD_VEHICLE_IMAGE_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchingUploadVehicleImage: true,
    };
  },
  [types.UPLOAD_VEHICLE_IMAGE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      vehicle: payload,
      fetchingUploadVehicleImage: false,
      fetchedUploadVehicleImageSuccess: true,
    };
  },
  [types.UPLOAD_VEHICLE_IMAGE_FAILED]: (state) => {
    return {
      ...state,
      fetchingUploadVehicleImage: false,
    };
  },
  // BULK UPLOAD
  [types.FETCH_BULK_UPLOAD_REQUEST]: (state) => {
    return {
      ...state,
      fetchingBulkUpload: true,
      fetchedBulkUpload: false,
    };
  },
  [types.FETCH_BULK_UPLOAD_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingBulkUpload: false,
      fetchedBulkUpload: true,
    };
  },
  [types.FETCH_BULK_UPLOAD_FAILED]: (state) => {
    return {
      ...state,
      fetchingBulkUpload: false,
      fetchedBulkUpload: false,
    };
  },
  [types.RESET_BULK_UPLOAD]: (state) => {
    return {
      ...state,
      fetchingBulkUpload: false,
      fetchedBulkUpload: false,
    };
  },
  // SHARING SERVICE FOR MULTIPLE VEHICLES
  [types.FETCH_BULK_SHARING_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUpdateSharing: true,
      fetchedUpdateSharing: false,
    };
  },
  [types.FETCH_BULK_SHARING_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingUpdateSharing: false,
      fetchedUpdateSharing: true,
    };
  },
  [types.FETCH_BULK_SHARING_FAILED]: (state) => {
    return {
      ...state,
      fetchingUpdateSharing: false,
      fetchedUpdateSharing: false,
    };
  },
  [types.RESET_UPDATE_SHARING]: (state) => {
    return {
      ...state,
      fetchingUpdateSharing: false,
      fetchedUpdateSharing: false,
    };
  },
  // BULK UNSHARE SERVICE FOR MULTIPLE VEHICLES
  [types.FETCH_BULK_UNSHARE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingBulkUnshareServices: true,
      fetchedBulkUnshareServices: false,
    };
  },
  [types.FETCH_BULK_UNSHARE_SUCCESS]: (state) => {
    return {
      ...state,
      fetchingBulkUnshareServices: false,
      fetchedBulkUnshareServices: true,
    };
  },
  [types.FETCH_BULK_UNSHARE_FAILED]: (state) => {
    return {
      ...state,
      fetchingBulkUnshareServices: false,
      fetchedBulkUnshareServices: false,
    };
  },
  [types.RESET_BULK_UNSHARE]: (state) => {
    return {
      ...state,
      fetchingBulkUnshareServices: false,
      fetchedBulkUnshareServices: false,
    };
  },
  // RESET UPLOAD VEHICE IMAGE
  [types.RESET_UPLOAD_VEHICLE_IMAGE_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      fetchingUploadVehicleImage: false,
      fetchedUploadVehicleImageSuccess: false,
    };
  },
  // RESET UPLOAD VEHICE TYPE IMAGE
  [types.RESET_UPLOAD_VEHICLE_TYPE_IMAGE_SUCCESS]: (state) => {
    return {
      ...state,
      loading: false,
      fetchingUploadVehicleTypeImage: false,
      fetchedUploadVehicleTypeImageSuccess: false,
    };
  },
  // GET BROKER SETTINGS
  [types.FETCH_GET_BROKER_SETTINGS_REQUEST]: (state) => {
    return {
      ...state,
      fetchedBrokerSettingsSuccess: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_GET_BROKER_SETTINGS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedBrokerSettingsSuccess: FETCH_STATE.DONE,
      brokerSettings: payload.data,
    };
  },
  [types.FETCH_GET_BROKER_SETTINGS_FAILED]: (state) => {
    return {
      ...state,
      fetchedBrokerSettingsSuccess: FETCH_STATE.FAILED,
    };
  },
  // UPDATE BROKER SETTINGS
  [types.FETCH_UPDATE_BROKER_SETTINGS_REQUEST]: (state) => {
    return {
      ...state,
      updatedBrokerSettingsSucces: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_UPDATE_BROKER_SETTINGS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      brokerSettings: payload.data,
      updatedBrokerSettingsSucces: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_UPDATE_BROKER_SETTINGS_FAILED]: (state) => {
    return {
      ...state,
      updatedBrokerSettingsSucces: FETCH_STATE.FAILED,
    };
  },
  [types.RESET_UPDATE_BROKER_SETTING_SUCCESS]: (state) => {
    return {
      ...state,
      updatedBrokerSettingsSucces: FETCH_STATE.UNSENT,
    };
  },

  // GET VEHICLES STATUSES BY ID
  [types.FETCH_VEHICLE_STATUSES_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loadingVehicleStatuses: true,
    };
  },
  [types.FETCH_VEHICLE_STATUSES_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loadingVehicleStatuses: FETCH_STATE.DONE,
      vehicleStatuses: payload.data,
      vehicleStatusesPagination: payload.pagination,
    };
  },
  [types.FETCH_VEHICLE_STATUSES_BY_ID_FAILED]: (state, { error }) => {
    return {
      ...state,
      loadingVehicleStatuses: FETCH_STATE.ERROR,
      vehicleStatuses: {},
      errors: {
        vehicles: error,
      },
    };
  },
  [types.RESET_VEHICLE]: (state) => {
    return {
      ...state,
      vehicle: {},
      errors: {},
      fetchUpdateVehicleGroup: FETCH_STATE.UNSENT,
    };
  },
});

export default vehicleReducer;
